module.exports = __webpack_public_path__ + "static/media/folhas.8673fcd2.jpg";